import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import HoldingCompany from "@/components/HoldingCompany";
import PlanByNumbers from "@/components/PlanByNumbers";
import AssetClasses from "@/components/AssetClasses";
import Enquiry from "@/components/Enquiry";
import Footer from "@/components/Footer";

function App() {
    return (
        <div className="App relative grain">
            <Navbar />
            <main>
                <Hero />
                <HoldingCompany />
                <PlanByNumbers />
                <AssetClasses />
                <Enquiry />
            </main>
            <Footer />
            <Toaster position="bottom-right" theme="dark" />
        </div>
    );
}

export default App;
